import { io } from 'socket.io-client';
import { API_URL } from '../config';

const SOCKET_URL = API_URL.replace('/api', '');

const socket = io(SOCKET_URL, {
    autoConnect: false,
    reconnection: true,
});

export default socket;
